<div class="container-fluid main-container">
  <div class="modal-popup" *ngIf="showDeleteBox">
    <div class="confirm-popup-content">
      <div class="popup-content-confirm">
        <h1>{{constants.DELETE_TEXT}}</h1>
        <button [disabled]="isRemoving" type="button" class="secondyes-button" (click)=onClickRemove()>
          <span *ngIf="isRemoving" class="spinner-border spinner-border-sm name-update-spinner" role="status"
            aria-hidden="true"></span>
          {{isRemoving ? '' : constants.YES}}
        </button>
        <button type="button" class="cancel-button" (click)=closeDialog()>
          Cancel
        </button>
      </div>
    </div>
  </div>
  <nav class="close-icon" id="normal-screen">
    <img [src]="constants.EDIT_CLOSE" alt="close" class="close-icon-img" (click)=onClickClosePopup() />
  </nav>

  <div class="container inner-container" id="section-no-error">
    <form action="" [formGroup]="form">
      <div class="row section-row">
        <div class=" col-5 form-area " id="normal-screen">

          <div class="row ">
            <div class="Nickname col">
              <label for="nickname" class="input-title">{{constants.NICKNAME_TXT}}</label>
              <input placeholder="e.g Mungus" autofocus type="text" id="nickname" class="form-control"
              formControlName="nickName" (input)="nicknameValidationError = false" />
              <span class="error-message" *ngIf="form.get('nickName').errors?.maxlength">{{constants.NAME_MAXLENGTH_ERROR_TEXT}}</span>
                <span class="error-message" *ngIf="nicknameValidationError">Please enter valid name</span>
            </div>
            <div class="col"></div>
          </div>
          <div class="row  row-margin ">
            <div class="col m-b">
              <label for="location" class="input-title">{{constants.LOCATION_TXT}}</label>
              <input placeholder="e.g Espoo, Uusimaa" autofocus type="text" id="location" class="form-control"
                formControlName="location" (input)="locationValidationError = false" />
                <span class="error-message" *ngIf="form.get('location').errors?.maxlength">{{constants.LOCATION_MAXLENGTH_ERROR_TEXT}}</span>
                <span class="error-message" *ngIf="locationValidationError">Please enter valid location</span>
            </div>
            <div class="col"></div>
          </div>
          <div class="row  row-margin">
            <div class="col country-col">
              <label for="country" class="input-title">{{constants.COUNTRY_TXT}}</label>
              <select aria-placeholder="test" id="inputState" class="form-control m-b" [(ngModel)]="data.country"
                formControlName="country">
                <option selected>{{data.country}}</option>
                <option placeholder="Select country" *ngFor="let Country of constants.COUNTRY_LIST_TXT">
                  {{ Country["countryName"] }}
                </option>
              </select>
            </div>
          </div>
          <div class="row  row-margin ">
            <div class="timeAndDate">
              <div>
                <label for="timeRecording" class="input-title">{{constants.RECORDING_TIME_TXT}}</label>

                <input type="time" id="timeRecording" class="form-control m-b" formControlName="timeRecording" />
              </div>
              <div class="datefield">
                <label for="dateRecording" class="input-title ">{{constants.RECORDING_DATE_TXT}}</label>

                <input type="date" [max]="maxDate" id="dateRecording" class="form-control m-b"
                  formControlName="dateRecording" />
              </div>
            </div>
          </div>

        </div>
        <div class=" col-7" id="normal-screen">
          <div class="video-container">
            <video controls class="video-player" [src]="data.url"></video>
          </div>

          <div class="tag-container" id="tag-container">
            <div style="display: flex;">
              <div [ngClass]="animalActive ? 'checkbox-button-active' : 'checkbox-button'">
                <input (change)="onChangeTag('Animals')" class="tag-checkbox" id="animals" type="checkbox">
                <img class="checkbox-img" [src]="constants.CHECKBOX_WHITE_IMG" alt="">
                <img class="checkbox-close" [src]="constants.CLOSE_WHITE_IMG" alt="">
                <label for="animals" id="animals-label" class="label-text">{{constants.ANIMALS_TXT}}</label>
              </div>
              <div [ngClass]="rainActive ? 'checkbox-button-active' : 'checkbox-button'">
                <input (change)="onChangeTag('Rain')" class="tag-checkbox" id="rain" type="checkbox">
                <img class="checkbox-img" [src]="constants.CHECKBOX_WHITE_IMG" alt="">
                <img class="checkbox-close" [src]="constants.CLOSE_WHITE_IMG" alt="">
                <label for="rain" id="rain-label" class="label-text">{{constants.RAIN_TXT}}</label>
              </div>
              <div [ngClass]="snowActive ? 'checkbox-button-active' : 'checkbox-button'">
                <input (change)="onChangeTag('Snow')" class="tag-checkbox" id="snow" type="checkbox">
                <img class="checkbox-img" [src]="constants.CHECKBOX_WHITE_IMG" alt="">
                <img class="checkbox-close" [src]="constants.CLOSE_WHITE_IMG" alt="">
                <label for="snow" id="snow-label" class="label-text">{{constants.SNOW_TXT}}</label>
              </div>
              <div [ngClass]="cityActive ? 'checkbox-button-active' : 'checkbox-button'">
                <input (change)="onChangeTag('City')" class="tag-checkbox" id="city" type="checkbox">
                <img class="checkbox-img" [src]="constants.CHECKBOX_WHITE_IMG" alt="">
                <img class="checkbox-close" [src]="constants.CLOSE_WHITE_IMG" alt="">
                <label for="city" id="city-label" class="label-text">{{constants.CITY_TXT}}</label>
              </div>
            </div>
            <div style="display: flex;">
              <div [ngClass]="natureActive ? 'checkbox-button-active' : 'checkbox-button'">
                <input (change)="onChangeTag('Nature')" class="tag-checkbox" id="nature" type="checkbox">
                <img class="checkbox-img" [src]="constants.CHECKBOX_WHITE_IMG" alt="">
                <img class="checkbox-close" [src]="constants.CLOSE_WHITE_IMG" alt="">
                <label for="nature" id="nature-label" class="label-text">{{constants.NATURE_TXT}}</label>
              </div>
              <div [ngClass]="nightActive ? 'checkbox-button-active' : 'checkbox-button'">
                <input (change)="onChangeTag('Night')" class="tag-checkbox" id="night" type="checkbox">
                <img class="checkbox-img" [src]="constants.CHECKBOX_WHITE_IMG" alt="">
                <img class="checkbox-close" [src]="constants.CLOSE_WHITE_IMG" alt="">
                <label for="night" id="night-label" class="label-text">{{constants.NIGHT_TXT}}</label>
              </div>
              <div [ngClass]="dayActive ? 'checkbox-button-active' : 'checkbox-button'">
                <input (change)="onChangeTag('DayVideo')" class="tag-checkbox" id="day" type="checkbox">
                <img class="checkbox-img" [src]="constants.CHECKBOX_WHITE_IMG" alt="">
                <img class="checkbox-close" [src]="constants.CLOSE_WHITE_IMG" alt="">
                <label for="day" id="day-label" class="label-text">{{constants.DAY_TXT}}</label>
              </div>
              <div [ngClass]="interiorActive ? 'checkbox-button-active' : 'checkbox-button'">
                <input (change)="onChangeTag('Interiors')" class="tag-checkbox" id="interior" type="checkbox">
                <img class="checkbox-img" [src]="constants.CHECKBOX_WHITE_IMG" alt="">
                <img class="checkbox-close" [src]="constants.CLOSE_WHITE_IMG" alt="">
                <label for="interior" id="interior-label" class="label-text">{{constants.INTERIORS_TXT}}</label>
              </div>
            </div>
            <div style="display: flex;">
              <div [ngClass]="waterActive ? 'checkbox-button-active' : 'checkbox-button'">
                <input (change)="onChangeTag('Water')" class="tag-checkbox" id="water" type="checkbox">
                <img class="checkbox-img" [src]="constants.CHECKBOX_WHITE_IMG" alt="">
                <img class="checkbox-close" [src]="constants.CLOSE_WHITE_IMG" alt="">
                <label for="water" id="water-label" class="label-text">{{constants.WATER_TXT}}</label>
              </div>
            </div>
          </div>
          <div class="submit-button ">
            <button id="progress-button" [disabled]="isLoading || !form.valid" (click)="onSubmit($event)" class="progres-button">
              <span *ngIf="isLoading" class="spinner-border spinner-border-sm name-update-spinner" role="status"
                aria-hidden="true"></span>
              Save Details
            </button>
            <button class="submit-cancel-button" (click)="openDialog(data)">
              <span *ngIf="isRemoving" class="spinner-border spinner-border-sm name-update-spinner" role="status"
                aria-hidden="true"></span>
              Delete Submission
            </button>

          </div>
          <div class="confirm">
            <button type="button" id="confirm" class="btn btn-dark">{{constants.YOUR_TXT}}</button>
          </div>
        </div>
      </div>

      <div class="container " id="mobile-screen">
        <div class="closeMobileScreen2">
          <h2 class="edit-text2">
            Edit Window Details
          </h2>
          <nav class="close-button-mobile2">
            <img [src]="constants.EDIT_CLOSE" alt="close" class="close-icon-img" (click)=onClickClosePopup() />
          </nav>
        </div>

        <div>
          <video controls class="video-player" src="{{data.url}}">

          </video>

          <div class="form-area" id="mobile-form">
            <div class="row  row-margin">
              <div class="Nickname col">
                <label for="nickname" class="input-title">{{constants.NICKNAME_TXT}}</label>

                <input placeholder="e.g Mungus" autofocus type="text" id="nickname" class="form-control"
                  formControlName="nickName" (input)="nicknameValidationError = false" />
                  <span class="error-message" *ngIf="form.get('nickName').errors?.maxlength">{{constants.NAME_MAXLENGTH_ERROR_TEXT}}</span>
                <span class="error-message" *ngIf="nicknameValidationError">Please enter valid name</span>
              </div>

              <div class="col"></div>
            </div>
            <div class="row ">
              <div class="col m-b">
                <label for="location" class="input-title">{{constants.LOCATION_TXT}}</label>

                <input placeholder="e.g Espoo, Uusimaa" autofocus type="text" id="location" class="form-control"
                  formControlName="location" (input)="locationValidationError = false"/>
                  <span class="error-message" *ngIf="form.get('location').errors?.maxlength">{{constants.LOCATION_MAXLENGTH_ERROR_TEXT}}</span>
                <span class="error-message" *ngIf="locationValidationError">Please enter valid location</span>
              </div>
              <div class="col">
                <label for="country" class="input-title">{{constants.COUNTRY_TXT}}</label>

                <select aria-placeholder="test" id="inputState" class="form-control m-b" formControlName="country">
                  <option selected>{{data.country}}</option>
                  <option *ngFor="let Country of constants.COUNTRY_LIST_TXT">
                    {{ Country["countryName"] }}
                  </option>
                </select>
              </div>
            </div>
            <div class="row  ">
              <div class="col">
                <label for="timeRecording" class="input-title">{{constants.RECORDING_TIME_TXT}}</label>

                <input type="time" id="timeRecording" class="form-control m-b" formControlName="timeRecording" />
              </div>
              <div class="col">
                <label for="dateRecording" class="input-title">{{constants.RECORDING_DATE_TXT}}</label>
                <input type="date" [max]="maxDate" id="dateRecording" class="form-control m-b"
                  formControlName="dateRecording" />
              </div>
            </div>
            <div class="mt-1">
              <p class="input-title animate__animated animate__fadeInUp">
                {{constants.TAG_WINDOW_TXT}}
              </p>
            </div>

            <div class="checkbox-grid" id="tag-container">
              <div [ngClass]="animalActive ? 'checkbox-button-active' : 'checkbox-button'">
                <input (click)="onChangeTag('Animals')" class="tag-checkbox" id="animals" type="checkbox">
                <img class="checkbox-img" [src]="constants.CHECKBOX_WHITE_IMG" alt="">
                <img class="checkbox-close" [src]="constants.CLOSE_WHITE_IMG" alt="">
                <label for="animals" id="animals-label" class="label-text">{{constants.ANIMALS_TXT}}</label>
              </div>
              <div [ngClass]="rainActive ? 'checkbox-button-active' : 'checkbox-button'">
                <input (change)="onChangeTag('Rain')" class="tag-checkbox" id="rain" type="checkbox">
                <img class="checkbox-img" [src]="constants.CHECKBOX_WHITE_IMG" alt="">
                <img class="checkbox-close" [src]="constants.CLOSE_WHITE_IMG" alt="">
                <label for="rain" id="rain-label" class="label-text">{{constants.RAIN_TXT}}</label>
              </div>
              <div [ngClass]="snowActive ? 'checkbox-button-active' : 'checkbox-button'">
                <input (change)="onChangeTag('Snow')" class="tag-checkbox" id="snow" type="checkbox">
                <img class="checkbox-img" [src]="constants.CHECKBOX_WHITE_IMG" alt="">
                <img class="checkbox-close" [src]="constants.CLOSE_WHITE_IMG" alt="">
                <label for="snow" id="snow-label" class="label-text">{{constants.SNOW_TXT}}</label>
              </div>
              <div [ngClass]="cityActive ? 'checkbox-button-active' : 'checkbox-button'">
                <input (change)="onChangeTag('City')" class="tag-checkbox" id="city" type="checkbox">
                <img class="checkbox-img" [src]="constants.CHECKBOX_WHITE_IMG" alt="">
                <img class="checkbox-close" [src]="constants.CLOSE_WHITE_IMG" alt="">
                <label for="city" id="city-label" class="label-text">{{constants.CITY_TXT}}</label>
              </div>
              <div [ngClass]="natureActive ? 'checkbox-button-active' : 'checkbox-button'">
                <input (change)="onChangeTag('Nature')" class="tag-checkbox" id="nature" type="checkbox">
                <img class="checkbox-img" [src]="constants.CHECKBOX_WHITE_IMG" alt="">
                <img class="checkbox-close" [src]="constants.CLOSE_WHITE_IMG" alt="">
                <label for="nature" id="nature-label" class="label-text">{{constants.NATURE_TXT}}</label>
              </div>
              <div [ngClass]="nightActive ? 'checkbox-button-active' : 'checkbox-button'">
                <input (change)="onChangeTag('Night')" class="tag-checkbox" id="night" type="checkbox">
                <img class="checkbox-img" [src]="constants.CHECKBOX_WHITE_IMG" alt="">
                <img class="checkbox-close" [src]="constants.CLOSE_WHITE_IMG" alt="">
                <label for="night" id="night-label" class="label-text">{{constants.NIGHT_TXT}}</label>
              </div>
              <div [ngClass]="dayActive ? 'checkbox-button-active' : 'checkbox-button'">
                <input (change)="onChangeTag('DayVideo')" class="tag-checkbox" id="day" type="checkbox">
                <img class="checkbox-img" [src]="constants.CHECKBOX_WHITE_IMG" alt="">
                <img class="checkbox-close" [src]="constants.CLOSE_WHITE_IMG" alt="">
                <label for="day" id="day-label" class="label-text">{{constants.DAY_TXT}}</label>
              </div>
              <div [ngClass]="interiorActive ? 'checkbox-button-active' : 'checkbox-button'">
                <input (change)="onChangeTag('Interiors')" class="tag-checkbox" id="interior" type="checkbox">
                <img class="checkbox-img" [src]="constants.CHECKBOX_WHITE_IMG" alt="">
                <img class="checkbox-close" [src]="constants.CLOSE_WHITE_IMG" alt="">
                <label for="interior" id="interior-label" class="label-text">{{constants.INTERIORS_TXT}}</label>
              </div>
              <div [ngClass]="waterActive ? 'checkbox-button-active' : 'checkbox-button'">
                <input (change)="onChangeTag('Water')" class="tag-checkbox" id="water" type="checkbox">
                <img class="checkbox-img" [src]="constants.CHECKBOX_WHITE_IMG" alt="">
                <img class="checkbox-close" [src]="constants.CLOSE_WHITE_IMG" alt="">
                <label for="water" id="water-label" class="label-text">{{constants.WATER_TXT}}</label>
              </div>
            </div>

            <div class="submit-button ">
              <button id="progress-button" [disabled]="isLoading || !form.valid" (click)="onSubmit($event)" class="progres-button">
                <span *ngIf="isLoading" class="spinner-border spinner-border-sm name-update-spinner" role="status"
                  aria-hidden="true"></span> SAVE DETAILS
              </button>
              <button class="submit-cancel-button" (click)="openDialog(data)">
                <span *ngIf="isRemoving" class="spinner-border spinner-border-sm name-update-spinner" role="status"
                  aria-hidden="true"></span>
                Delete
              </button>
            </div>

          </div>
        </div>

      </div>

    </form>
  </div>
</div>